export default "__VITE_ASSET__pBj0HQ81__"